export enum EventRequestRole {
  allowRequest = 'allowRequest',
  approveRequest = 'approveRequest',
}
